'use client';

import React, { useState, useEffect } from 'react';
import { RefreshCw, Plus } from 'lucide-react';
import Link from 'next/link';

export default function DashboardHeader() {
  const [lastUpdated, setLastUpdated] = useState('');
  const [refreshing, setRefreshing] = useState(false);

  useEffect(() => {
    setLastUpdated('Today at 12:50 PM');
  }, []);

  function handleRefresh() {
    setRefreshing(true);
    setTimeout(() => setRefreshing(false), 1200);
  }

  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <div>
        <h1 className="text-2xl font-700 text-foreground tracking-tight">Collection Overview</h1>
        <p className="text-sm text-muted-foreground mt-0.5">
          {lastUpdated ? `Last updated ${lastUpdated}` : 'Loading...'}
          {' '}· Marcus Webb&apos;s Vault
        </p>
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={handleRefresh}
          className="flex items-center gap-1.5 px-3 py-2 text-sm font-500 text-muted-foreground border border-border rounded-lg hover:bg-muted transition-all duration-150 active:scale-95"
        >
          <RefreshCw size={14} className={refreshing ? 'animate-spin' : ''} />
          Refresh
        </button>
        <Link
          href="/guitar-collection"
          className="flex items-center gap-1.5 px-4 py-2 text-sm font-600 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-all duration-150 active:scale-95 shadow-sm"
        >
          <Plus size={14} />
          Add Guitar
        </Link>
      </div>
    </div>
  );
}